module.exports = __webpack_public_path__ + "media/images/main-background-beach-a26e2cc3.jpg";